/* eslint no-await-in-loop: 0 no-restricted-syntax: 0 */
import React, { useState } from 'react';

import { useLazyQuery } from 'react-apollo';
import { useLocation } from 'react-router-dom';

import * as actions from 'actions';
import { useDispatch, useSelector } from 'Hooks';

// import { CREATE_TEMP_USER_QUERY } from './queries';
import AddCompany from './views/AddCompanyView';
import RegisterUserView from './views/RegisterUserView';

const Register: React.FunctionComponent = () => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formDataVals = useSelector((state) => {
    return (
      state.tempUser || {
        phoneOrEmail: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        brandName: '',
        language: '',
        currency: '',
      }
    );
  });

  // const [registerTemporary, { called, data }] = useLazyQuery(CREATE_TEMP_USER_QUERY, {
  //   variables: {
  //     username: formDataVals.phoneOrEmail,
  //     name: formDataVals.firstName + ' ' + formDataVals.lastName,
  //     password: formDataVals.password,
  //     companyName: formDataVals.brandName,
  //     companyLanguage: formDataVals.language,
  //     companyCurrency: formDataVals.currency,
  //   },
  //   fetchPolicy: 'network-only',
  // });

  const { pathname } = useLocation();

  const handleSetField = (fieldName: string, fieldValue: string) => {
    dispatch(actions.setTempUserFields({ ...formDataVals, [fieldName]: fieldValue }));
  };

  const handleRegister = async () => {
    // await registerTemporary();
  };

  return (
    <>
      {pathname === '/register' && (
        <RegisterUserView
          onSetField={handleSetField}
          phoneOrEmail={formDataVals.phoneOrEmail}
          password={formDataVals.password}
          confirmPassword={formDataVals.confirmPassword}
          firstName={formDataVals.firstName}
          lastName={formDataVals.lastName}
          loading={loading}
        />
      )}
      {pathname === '/register/add-company' && (
        <AddCompany
          onSetField={handleSetField}
          onRegister={handleRegister}
          brandName={formDataVals.brandName}
          language={formDataVals.language}
          currency={formDataVals.currency}
          errors={errors}
          loading={loading}
        />
      )}
    </>
  );
};

export default Register;
